import React from 'react';
import { useNavigate } from 'react-router';
import { useAtomValue } from 'jotai';
import { QRCodeSVG } from 'qrcode.react';

import { ButtonDesktop } from '@alfalab/core-components/button/desktop';
import { Typography } from '@alfalab/core-components/typography';

import { qrPageDataAtom } from '../../../shared/atoms/money-pool-data/atom';
import { qrInfoAtom } from '../../../shared/atoms/money-pool-qr/atom';
import { Layout } from '../../components/layout';

import styles from './index.module.css';

export const MoneyPoolQR = () => {
    const navigate = useNavigate();

    const qrCodeUrl = useAtomValue(qrInfoAtom);
    const { comment, categoryName } = useAtomValue(qrPageDataAtom);

    const handleGoBack = () => {
        navigate('..', { relative: 'path' });
    };

    return (
        <Layout>
            <div className={styles.content}>
                <Typography.Title tag='h3' view='medium' className={styles.category}>
                    {categoryName}
                </Typography.Title>
                {comment && <Typography.Text view='primary-large'>{comment}</Typography.Text>}
                <QRCodeSVG
                    value={qrCodeUrl}
                    size={300}
                    className={styles.qrCode}
                    data-test-id='transfer-qr'
                />
                <Typography.Title tag='h5' view='xsmall' className={styles.title}>
                    Отсканируйте QR-код камерой телефона
                </Typography.Title>
                <Typography.Text
                    tag='p'
                    view='secondary-medium'
                    weight='bold'
                    className={styles.description}
                >
                    После сканирования вы перейдёте в сервис СБП и выберете удобный банк для
                    перевода
                </Typography.Text>
                <ButtonDesktop view='primary' block={true} onClick={handleGoBack}>
                    Готово
                </ButtonDesktop>
            </div>
        </Layout>
    );
};
